import * as React from "react"
import { connect } from "react-redux"
import { setFilters } from "../../filters/actions"
import type { FiltersIdentifier, FiltersObject } from "../../filters/types"
import { isStateLoading } from "../../filters/selectors"
import { cookieNames, setCookie } from "../../../utils/cookies"
import { MultiSelect, MultiSelectItem } from "../../uiKit/MultiSelect/MultiSelect"
import { getLocationPickerSelectedIds, getLocationsForLocationPicker } from "./selectors"

type Props = {
    className?: string
    style?: Record<string, any>
    locations: MultiSelectItem[]
    selectedsLocationsIds: string[]
    identifier: FiltersIdentifier
    dataLoading: boolean
    filters: FiltersObject
    setFilters: (identifier: FiltersIdentifier, attributes: any) => void
}

const defaultStyles = {
    width: "13rem",
}

class LocationsSelectFilterComponent extends React.PureComponent<Props> {
    handleSetLocationsFilter = (selectedIds: string[]) => {
        setCookie(cookieNames.locationFilterIds, JSON.stringify(selectedIds))
        this.props.setFilters(this.props.identifier, {
            location_name: selectedIds,
        })
    }

    render() {
        return (
            <div style={{ ...defaultStyles, ...this.props.style }} className={this.props.className}>
                <MultiSelect
                    data={this.props.locations}
                    onChange={this.handleSetLocationsFilter}
                    value={this.props.selectedsLocationsIds}
                    labels={{
                        allSelected: () => "All Locations",
                        noSelected: <span className="text-[#ff9800]">No Locations selected</span>,
                        countSelected: (count: number) => `${count} Locations`,
                        singleSelected: (label: string) => label,
                    }}
                />
            </div>
        )
    }
}

const mapStateToProps = (state, props) => ({
    locations: getLocationsForLocationPicker(state),
    selectedsLocationsIds: getLocationPickerSelectedIds(state, props.identifier),
    dataLoading: isStateLoading(state, props.identifier),
})

const mapDispatchToProps = {
    setFilters: setFilters,
}
export default connect<any, any, any>(mapStateToProps, mapDispatchToProps)(LocationsSelectFilterComponent)
